export default {
  toggleGrowthHeight: true,
  toggleSoilMoisture: false,
  checkboxes: [],
  showComparison: false,
  getComparisonData: true,
  hiddenComparisonData: true
}
